import { render, staticRenderFns } from "./TheMenuContainer.vue?vue&type=template&id=98b812b8&scoped=true"
import script from "./TheMenuContainer.vue?vue&type=script&lang=js"
export * from "./TheMenuContainer.vue?vue&type=script&lang=js"
import style0 from "./TheMenuContainer.vue?vue&type=style&index=0&id=98b812b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b812b8",
  null
  
)

export default component.exports